import { render } from "./YouTubeVideo.vue?vue&type=template&id=490dc444"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js"

import "./YouTubeVideo.vue?vue&type=style&index=0&id=490dc444&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__